import renderTemplate from '@intercom/pulse/lib/render-template';
import HtmlEscaper from '@intercom/embercom-composer/lib/html-escaper';
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import $ from 'jquery';
import Em from 'ember';
function _getAttributeContent(attribute, context) {
  let $currentAttribute = $(attribute);
  let identifier = $currentAttribute.attr('data-identifier');
  let contentToFill = context[identifier];
  if (!contentToFill) {
    let fallback = $currentAttribute.attr('data-fallback');
    contentToFill = fallback || '';
  }
  return HtmlEscaper.escape(contentToFill);
}
function _renderAttributePills(template, context) {
  // eslint-disable-next-line jquery-unsafe/no-html
  let $html = $('<div></div>').html(template);
  let $attributes = $html.find('ic-attribute');
  $attributes.each(function () {
    this.outerHTML = sanitizeHtml(_getAttributeContent(this, context));
  });
  return $html.html();
}
function _escapeContext(unsafeContext) {
  let safeContext = {};
  Object.keys(unsafeContext).forEach(key => {
    safeContext[key] = Em.Handlebars.Utils.escapeExpression(unsafeContext[key]);
  });
  return safeContext;
}
export default function renderPreview(template, context = {}) {
  context = _escapeContext(context);
  template = renderTemplate(template, context);
  template = _renderAttributePills(template, context);
  return template;
}